import { isNonEmptyArray } from 'utils/functions';

import type { TemplateModelData } from 'types/types';

export const filterBySearch = (posts: TemplateModelData[], builderIds: string[]): TemplateModelData[] =>
  posts.filter(post => builderIds.includes(post?.id || ''));

const getFirstPublished = (post: any) =>
  post?.data?.templateInfo?.entryDetails?.firstPublished ?? post?.firstPublished ?? 0;

const sortByFirstPublished = (posts: any[]) => posts.sort((a, b) => getFirstPublished(b) - getFirstPublished(a));

export const filterByMedicalSpecialty = (posts: TemplateModelData[], medicalSpecialty: string[]): TemplateModelData[] =>
  posts.filter(post => {
    const specialties = post?.data?.templateInfo?.filters?.specialty || [];

    return medicalSpecialty.some(specialty => specialties.includes(specialty));
  });

export const filterByInterest = (posts: TemplateModelData[], interests: string[]): TemplateModelData[] =>
  posts.filter(post => {
    const topics = post?.data?.templateInfo?.filters?.topic || [];

    return Array.isArray(topics)
      ? interests.some(interest => topics.includes(interest))
      : interests.includes(topics);
  });

export const filterByResourceType = (posts: TemplateModelData[], resourceTypeList: string[]): TemplateModelData[] =>
  posts.filter(post => resourceTypeList.includes(post?.modelId || ''));

const getFilteredPosts = (
  builderIds: string[],
  medicalSpecialty: string[] | null,
  convertedResources: string[] | null,
  interests: string[] | null,
  nonFilteredPosts: TemplateModelData[],
  emptySearch: boolean,
): TemplateModelData[] => {
  let filteredPosts = nonFilteredPosts;

  if (!emptySearch) {
    filteredPosts = filterBySearch(filteredPosts, builderIds);
  }
  if (isNonEmptyArray(medicalSpecialty)) {
    filteredPosts = filterByMedicalSpecialty(filteredPosts, medicalSpecialty);
  }
  if (isNonEmptyArray(convertedResources)) {
    filteredPosts = filterByResourceType(filteredPosts, convertedResources);
  }
  if (interests) {
    filteredPosts = filterByInterest(filteredPosts, interests);
  }

  filteredPosts = sortByFirstPublished(filteredPosts);

  return filteredPosts;
};

export default getFilteredPosts;
